import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

/**
 * Custom coastal-blue marker icon (no default Leaflet asset dependency).
 */
const coastalIcon = L.divIcon({
  className: "gcw-marker",
  html: `<div style="width:28px;height:28px;background:#165a71;border:3px solid #fff;border-radius:50%;box-shadow:0 6px 16px rgba(7,27,34,0.35);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:11px;">GC</div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    const b = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    if (b.isValid()) map.fitBounds(b, { padding: [30, 30] });
  }, [points, map]);
  return null;
}

export default function MapView({ items = [], height = 480 }) {
  const points = items.filter((s) => typeof s.latitude === "number" && typeof s.longitude === "number").map((s) => ({
    id: s.id,
    slug: s.slug || s.id,
    title: s.title,
    price: s.base_price,
    img: s.featured_image,
    lat: s.latitude,
    lng: s.longitude,
    rating: s.rating_avg,
  }));

  const center = points[0] ? [points[0].lat, points[0].lng] : [30.4, -87.9];

  return (
    <div
      data-testid="map-view"
      className="rounded-2xl overflow-hidden border border-slate-200 bg-white"
      style={{ height }}
    >
      <MapContainer center={center} zoom={7} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true}>
        <TileLayer
          attribution='© <a href="https://openstreetmap.org">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {points.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={coastalIcon}>
            <Popup>
              <Link to={`/services/${p.slug}`} className="flex gap-3 items-start no-underline">
                {p.img && (
                  <img src={p.img} alt="" className="h-14 w-14 rounded-lg object-cover shrink-0" />
                )}
                <div>
                  <div className="font-semibold text-[#071b22] text-sm">{p.title}</div>
                  <div className="text-xs text-[#252A34]/70 mt-0.5">
                    ${p.price} · ★ {(p.rating || 0).toFixed(1)}
                  </div>
                  <div className="text-xs text-[#165a71] font-medium mt-1">View service →</div>
                </div>
              </Link>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
